/**
 * Lectura de montos escritos a mano, en formato colombiano.
 *
 * En Colombia los miles se separan con punto: la app misma muestra
 * "$1.350.000" (toLocaleString("es-CO")), así que es exactamente lo que el
 * director copia del recibo del banco. `parseFloat("1.350.000")` devuelve
 * 1.35, y ese número entraba tal cual a la base: en el campamento FIEL
 * CONQUISTADOR quedaron 11 pagos así (ARMOHET "1.12" por $1.120.000, BETANIA
 * "1" por $1.000.000, SARON "620"…) que un admin tuvo que corregir a mano.
 *
 * Acepta "1200000", "1.200.000", "1,200,000", "1200000.50" y "1200000,50".
 * Devuelve pesos enteros, o null si no se puede leer un número válido.
 */
export function parseAmountCOP(input: string): number | null {
  const cleaned = String(input ?? "")
    .replace(/\s+/g, "")
    .replace(/[^\d.,-]/g, "")
    .replace(/[.](?=\d{3}(\D|$))/g, "") // separador de miles con punto
    .replace(/,(?=\d{3}(\D|$))/g, "") // separador de miles con coma
    .replace(/,(\d{1,2})$/, ".$1"); // coma decimal → punto
  if (cleaned === "" || cleaned === "-") return null;
  const n = Number(cleaned);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n);
}

/** "$1.350.000" — para confirmarle al usuario lo que se va a guardar. */
export function formatCOP(amount: number): string {
  return `$${amount.toLocaleString("es-CO")}`;
}
